import React, { useState } from 'react';
import {
  Button,
  PagesectionSubsection,
  Tabs,
  TabsPanel,
} from '@ktag/styleguide/dist/react';
import { Attributes, JobResult } from 'jobs.types';
import { useTranslation } from 'react-i18next';
import AdminViewTab from './AdminViewTab';
import AdminViewJobSearch from './AdminViewJobSearch';
import { BEFRISTUNG_ATTRIBUTE_ID, HOMEOFFICE_ATTRIBUTE_ID } from '../../constants';
import AdminViewHierarchy from './AdminViewHierarchy';

const EXCLUDE_ATTRIBUTES = [HOMEOFFICE_ATTRIBUTE_ID, BEFRISTUNG_ATTRIBUTE_ID];

interface Props {
  attributes: Attributes;
  jobs: JobResult[];
}

const AdminView = ({ attributes, jobs }: Props) => {
  const { t } = useTranslation('jobs');

  const [searchTerm, setSearchTerm] = useState('');

  if (!attributes) {
    return null;
  }

  const getUrlSearchParams = () => {
    const params = new URLSearchParams(window.location.search);
    return Boolean(params.get('admin'));
  };

  if (!getUrlSearchParams()) {
    return null;
  }

  const removeAdminView = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete('admin');
    window.history.replaceState({}, '', window.location.pathname);
    window.location.reload();
  };

  const filteredAttributes = Object.entries(attributes).filter(
    ([key]) => !EXCLUDE_ATTRIBUTES.includes(key),
  );

  return (
    <PagesectionSubsection type="standard">
      <h2 className="h2">{t('adminview_title')}</h2>
      <Tabs additionalClassNames="adminview__tabs">
        <TabsPanel label={t('adminview_jobs')} hash="jobs">
          <AdminViewJobSearch
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            jobs={jobs}
          />
        </TabsPanel>
        {filteredAttributes.map(([key, value]) => (
          <TabsPanel label={value.name} key={key} hash={value.name.toLowerCase()}>
            <AdminViewTab key={key} value={value} />
          </TabsPanel>
        ))}
        <TabsPanel label={t('adminview_hierarchy')} hash="hierarchies">
          <AdminViewHierarchy />
        </TabsPanel>
      </Tabs>
      <Button
        additionalClassNames="adminview__leave"
        primary
        danger
        onClick={removeAdminView}
      >
        {t('adminview_leave')}
      </Button>
    </PagesectionSubsection>
  );
};

export default AdminView;
